import { Component, Inject, OnInit, Renderer2, ViewEncapsulation } from '@angular/core';
import { environment } from '../../environments/environment';
import { CommonService } from '../core/services/common.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { SeoService } from '../core/services/seo.service';
import { TranslateService } from '@ngx-translate/core';
import { Title } from '@angular/platform-browser';
declare const $: any;
declare const jQuery: any;
declare const grecaptcha: any;

@Component({
  selector: 'app-contact-us',
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.scss'],
  // encapsulation: ViewEncapsulation.None
})
export class ContactUsComponent implements OnInit {
  timeZones: any[] = [];
  purposes: any[] = [
    'Sales',
    'Support',
    'Leads',
    'Orders',
    'Disputes',
    'Subscription',
  ];
  priorities: any[] = [
    { id: 1, name: 'Critical' },
    { id: 2, name: 'High' },
    { id: 3, name: 'Medium' },
    { id: 4, name: 'Low' },
  ];
  home = { label: "Home", routerLink: "/en" };
  items = [ { label: "Contact us" , routerLink: this.router.url} ];
  contactUsForm: FormGroup;
  
  constructor(
    private commonService: CommonService,
    private formBuilder: FormBuilder,
    private router : Router,
    private seo :SeoService, private translate : TranslateService,private titleService : Title
  ) {}
  contactPathUrl: any;
  public env = environment;
  delawareTime: string;
  newJerseyTime: string;
  hyderabadTime: string;
  appsUrl = environment.CMS_APPS_URL;
  public websiteUrl = environment.WEBSITE_URL;
  ngOnInit(): void {
    
    this.contactPathUrl = environment.imgpathUrl;
    this.initializeContactUsForm();
    this.getAllTimeZones();
    // Set time zones for each location
    const delawareTimezone = 'America/New_York';
    const newJerseyTimezone = 'America/New_York';
    const hyderabadTimezone = 'Asia/Kolkata';

    // Get current time for each location
      this.delawareTime = this.formatTime(new Date(), delawareTimezone);
      this.newJerseyTime = this.formatTime(new Date(), newJerseyTimezone);
      this.hyderabadTime = this.formatTime(new Date(), hyderabadTimezone);

    this.titleService.setTitle((this.translate.instant('contactUs.contactUsMetaTitle')));
        this.seo.updateMetaTagsInformation(this.translate.instant('contactUs.contactUsMetaTitle'),
         this.translate.instant('contactUs.contactUsMetaDesc'),'','../../assets/images/contact-us/contact-us-meta-sm.png' ,
         'en/contact-us')
  }

// Function to format time
formatTime(date: Date, timezone: string): string {
  const options: Intl.DateTimeFormatOptions = {
    timeZone: timezone,
    hour12: true,
    hour: 'numeric',
    minute: 'numeric',
  };

  return new Intl.DateTimeFormat('en-US', options).format(date);
}


  public validateCaptcha() {
    $('#recaptchaError').addClass('d-none');
    if (!grecaptcha.getResponse()) {
      $('#recaptchaError').removeClass('d-none');
    }
    return grecaptcha.getResponse() ? true : false;
  }

  public getAllTimeZones() {
    this.commonService.getAllTimeZones('+05:30').subscribe((res: any) => {
      this.timeZones = res.message.allTimeZones;
    });
  }

  private initializeContactUsForm() {
    this.contactUsForm = this.formBuilder.group({
      userName: ['', Validators.required],
      userEmail: ['', [Validators.required, Validators.email]],
      userPhone: ['', [Validators.required, Validators.pattern("^[0-9]*$")]],
      purpose: ['', Validators.required],
      priority: ['', Validators.required],
      userTimezoneId: ['', Validators.required],
      subject: ['', Validators.required],
      description: [''],
    });
  }
  public checkError = (controlName: string, errorName: string) => {
    return this.contactUsForm.controls[controlName].hasError(errorName);
  };

  onSubmitcontactUsForm() {
    const isCaptchaVerified = this.validateCaptcha();
    if (this.contactUsForm.valid && isCaptchaVerified) {
      //console.log(this.contactUsForm.value);
    }
  }

  onItemClick(event) {
    if (event.item && event.item.routerLink) {
      this.router.navigateByUrl(event.item.routerLink);
    }
  }
}
